export type ActionProps<T> = {
  [K in keyof T as T[K] extends (...args: any[]) => any ? K : never]: T[K]
}

export function extractActions<T extends Record<string, unknown>>(api: {
  getState: () => T
}): ActionProps<T> {
  const state = api.getState()
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(state)) {
    if (typeof value === "function") {
      out[key] = value
    }
  }
  return out as ActionProps<T>
}
